export default __webpack_public_path__ + "static/media/customer_main_banner.ca5714dd.jpg";